<div class="d-flex text-center flex-column">
    <div class="logo mb-3" [ngStyle]="{'background-image': 'url(' + logo + ')'}"></div>
    <span class="t6 bold">Stock Care</span>
    <span class="t3">{{ version }}</span>
    <span class="t2 bold">{{ environment.production ? 'Production' : 'QAS' }}</span>

    <span class="t3 bold">{{ device.name }}</span>
    <div>
        <span class="t1">{{ device.stockLocationName }}</span>
        <span>|</span>
        <span class="t1">{{ device.physicalLocationName }}</span>
    </div>

    <span class="t2">&copy;2019 Britehouse</span>
</div>
